/**
 * Deploy Service
 * Экспорт статического HTML
 */
import { generateHTML } from './generator';

/**
 * Скачивание HTML файла
 */
export function downloadHTML(pageData, options = {}) {
  const html = generateHTML(pageData, options);
  const filename = options.filename || 'index.html';

  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return html;
}
